import {
  prettyStatusLabel,
  uploadItemInProgress,
  type UploadStatus,
} from "@shared-components/upload/file-upload-provider";
import { ListItem } from "@shared-components/list-item";
import { Badge } from "@shared-components/shadcn/badge";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@shared-components/shadcn/popover";
import { CloudUpload } from "lucide-react";
import { Button } from "./shadcn/button";
import _ from "lodash";
import { useFileUploadStatus } from "./upload/use-file-upload-status";
import { ActivityIndicator } from "@shared-components/activity-indicator";

export const getBadgeFromUploadStatus = (status: UploadStatus) => {
  const statusLabel = prettyStatusLabel(status);
  switch (status) {
    case "creatingMetadata":
    case "metadataCreated":
    case "uploading":
    case "uploadCompleted":
    case "processing":
      return <Badge variant={"yellow"}>{statusLabel}</Badge>;
    case "completed":
      return <Badge variant={"green"}> {statusLabel} </Badge>;
    case "error":
      return <Badge variant={"red"}> {statusLabel} </Badge>;
    case "pending":
    case "removed":
      return <Badge variant={"secondary"}> {statusLabel} </Badge>;
  }
};

export const FileUploadStatusPopover = () => {
  const { items } = useFileUploadStatus();

  const filteredItems = items.filter((item) => item.status !== "removed");
  if (filteredItems.length === 0) return null;

  const hasActiveUploads = items.some((item) =>
    uploadItemInProgress(item.status),
  );

  return (
    <Popover>
      <PopoverTrigger asChild className="relative">
        <Button variant="ghost" className="relative px-2">
          <div className="relative">
            <CloudUpload />
            {hasActiveUploads && (
              <div className="bg-ter-blue-500  w-4 h-4 rounded-full flex items-center justify-center absolute -top-1 -right-1 ">
                <ActivityIndicator className="stroke-background" size="xxs" />
              </div>
            )}
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="flex flex-col p-0 w-[300px] max-h-[500px]"
      >
        <div className="p-2">
          <h4>{"Upload status"}</h4>
        </div>
        <div className="overflow-y-auto">
          {filteredItems.map((item) => (
            <ListItem
              key={item.key}
              className="whitespace-nowrap flex flex-1 justify-between item-center gap-1"
            >
              <span className="truncate">{item.file?.name}</span>
              {getBadgeFromUploadStatus(item.status)}
            </ListItem>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
